import React, {FC, useEffect, useState} from "react";
import GatewayService, {Client} from "../service/GatewayService";
import {Info} from "../service/Info";
import {toast} from "react-hot-toast";

const LoginComponent: FC = () => {
    const [totps, setTOTPs] = useState<{[clientId: string]: string}>({});
    const[logedInClients, setClients] = useState<Array<Client>>([]);
    const[info, setInfo] = useState<Info|undefined>(undefined);

    useEffect(() => {
        init()
    }, []);

    async function init() {
        let clients = await GatewayService.status()
        setClients(clients.filter(it => !it.ignore))
        let status = await GatewayService.getInfo()
        setInfo(status)
    }

    async function totpLogin(clientId: string, totpOverride?: string) {
        const totp = totpOverride ?? (totps[clientId] || "");
        toast("logging in ... ")
        let resp = await GatewayService.login(clientId, totp)
        toast(JSON.stringify(resp))
        setTOTPs(t => ({...t, [clientId]: ""}));
        init()
    }

    let loggedInClientIds = logedInClients.map(e=>e.user_id)
    if (info===undefined)return <>LOADING...</>
    return (
        <div className="login-card">
            <a href={"https://developers.kite.trade/apps"} target="_blank">qqAccount Login</a>
            <div className="login-broker-list">
                {info.brokerUrls.map(it => {
                    let isLoggedIn = loggedInClientIds.indexOf(it.clientId)!==-1
                    return (
                        <div className="login-broker-item" key={it.clientId}>
                            {it.loginUrl !== null &&
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <span title="Copy URL" style={{cursor: 'pointer', marginLeft: '8px'}} onClick={() => {
                                        navigator.clipboard.writeText(it.clientId);
                                        toast.success('Copied client id!');
                                    }}>📋
                                    </span>
                                    <a className={isLoggedIn ? "login-broker-link logged-in" : "login-broker-link not-logged-in"} href={it.loginUrl} target="_blank">{it.clientId}</a>
                                    <span title="Copy URL" style={{cursor: 'pointer', marginLeft: '8px'}} onClick={() => {
                                        navigator.clipboard.writeText(it.loginUrl!);
                                        toast.success('Copied! Url');
                                    }}>
                                        📋
                                    </span>
                                </div>
                            }
                            {it.loginUrl === null &&
                                <div className="login-input-group">
                                    <input
                                        type="text"
                                        value={totps[it.clientId] || ""}
                                        onFocus={async () => {
                                            try {
                                                const text = await navigator.clipboard.readText();
                                                if (/^\d{6}$/.test(text)) {
                                                    setTOTPs(t => ({...t, [it.clientId]: text}));
                                                    await totpLogin(it.clientId, text);
                                                }
                                            } catch (err) {
                                                // ignore clipboard read errors, e.g. permissions
                                            }
                                        }}
                                        onChange={event => {
                                            const newTotp = event.target.value;
                                            setTOTPs(t => ({...t, [it.clientId]: newTotp}));
                                            if (newTotp.length === 6) {
                                                totpLogin(it.clientId, newTotp);
                                            }
                                        }}
                                        placeholder="TOTP"
                                    />
                                    <button
                                        className={isLoggedIn ? "logged-in" : "not-logged-in"}
                                        onClick={() => totpLogin(it.clientId)}
                                    >
                                        {it.clientId}
                                    </button>
                                </div>
                            }
                        </div>
                    )
                })}
            </div>
    </div>
    )
}

export default LoginComponent;
